module.exports = __webpack_public_path__ + "aws_logo_white.png";